module.exports = __webpack_public_path__ + "img/popup_main.0ce69505.png";